import axios from 'axios';

const addProductImage = (productId, file) => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('productId', productId);
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/product/addProductImage`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(res => res)
    .catch(err => err);
};

export default addProductImage;
